function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _to_primitive(input, hint) {
    if (_type_of(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_type_of(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _to_property_key(arg) {
    var key = _to_primitive(arg, "string");
    return _type_of(key) === "symbol" ? key : String(key);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useReducer } from "react";
import { isEmpty } from "../../utils";
import { CONTROL_ACTIONS, SETTER_ACTIONS } from "./types";
var context = {
    dispatch: function() {},
    state: {
        command: null,
        form: {}
    }
};
export var FormStateContext = /*#__PURE__*/ createContext(context);
export var FormStateWrapper = function(param) {
    var children = param.children, _param_initialValues = param.initialValues, initialValues = _param_initialValues === void 0 ? {} : _param_initialValues;
    var reducer = function(state, param) {
        var payload = param.payload, type = param.type;
        switch(type){
            case SETTER_ACTIONS.set:
                return _object_spread_props(_object_spread({}, state), {
                    form: _object_spread_props(_object_spread({}, state.form), _define_property({}, payload.fieldName, payload.value))
                });
            case SETTER_ACTIONS.insert:
                {
                    var value = Array.isArray(payload.value) ? payload.value : [
                        payload.value
                    ];
                    var insertState = state.form[payload.fieldName];
                    return _object_spread_props(_object_spread({}, state), {
                        form: _object_spread_props(_object_spread({}, state.form), _define_property({}, payload.fieldName, Array.isArray(insertState) ? _to_consumable_array(insertState).concat(_to_consumable_array(value)) : payload.value))
                    });
                }
            case SETTER_ACTIONS.remove:
                {
                    var removeState = state.form[payload.fieldName];
                    var isCheckbox = Array.isArray(removeState);
                    if (isCheckbox) {
                        var newCheckboxState = removeState.filter(function(item) {
                            return String(item) !== String(payload.value);
                        });
                        return _object_spread_props(_object_spread({}, state), {
                            form: _object_spread_props(_object_spread({}, state.form), _define_property({}, payload.fieldName, isEmpty(newCheckboxState) ? undefined : newCheckboxState))
                        });
                    }
                    var _state_form = state.form, _payload_fieldName = payload.fieldName, _ = _state_form[_payload_fieldName], rest = _object_without_properties(_state_form, [
                        _payload_fieldName
                    ].map(_to_property_key));
                    return _object_spread_props(_object_spread({}, state), {
                        form: rest
                    });
                }
            case CONTROL_ACTIONS.reset:
                return {
                    command: null,
                    form: _object_spread({}, payload)
                };
            case CONTROL_ACTIONS.command:
                return _object_spread_props(_object_spread({}, state), {
                    command: payload
                });
            default:
                throw new Error("Invalid action.");
        }
    };
    var _useReducer = _sliced_to_array(useReducer(reducer, {
        command: null,
        form: initialValues
    }), 2), state = _useReducer[0], dispatch = _useReducer[1];
    var value = useMemo(function() {
        return {
            dispatch: dispatch,
            state: state
        };
    }, [
        dispatch,
        state
    ]);
    return /*#__PURE__*/ _jsx(FormStateContext.Provider, {
        value: value,
        children: children
    });
};
export var useForm = function() {
    var _useContext = useContext(FormStateContext), dispatch = _useContext.dispatch, state = _useContext.state;
    return {
        set: function(payload) {
            var fieldName = Object.keys(payload)[0];
            var value = payload[fieldName];
            dispatch({
                payload: {
                    fieldName: fieldName,
                    value: value
                },
                type: SETTER_ACTIONS.set
            });
        },
        state: state.form,
        submit: function() {
            dispatch({
                payload: "submit",
                type: CONTROL_ACTIONS.command
            });
        }
    };
};

//# sourceMappingURL=FormStateWrapper.js.map